import { Component, Injector } from "@angular/core";
import { AppComponentBase } from "@shared/app-component-base";

@Component({
    selector: 'app-video-call-options',
    templateUrl: './video-call-options.component.html',
    styleUrls: ['./video-call-options.component.scss']
})
export class VideoCallOptionsComponent extends AppComponentBase {

    constructor(public injector: Injector) {
        super(injector);
    }
}
